import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { VideoRoutes } from "./routes";

const Video = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {VideoRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/video" />
      </Switch>
    </>
  );
};

export default Video;
